import React from 'react';
import { TextField } from '../../components/AtomComponents';
import type { ConnectorConfig, VanillaSettingsData } from './types';
import { StepCard, StepField, StepHeader, StepFormContainer } from './PxwStepComponents';

interface VanillaSettingsStepProps {
  data: VanillaSettingsData;
  onChange: (data: VanillaSettingsData) => void;
}

interface ConfigColumnProps {
  title: string;
  colClass: string;
  sectionLabelClass: string;
  config: ConnectorConfig;
  prefix: string;
  onChange: (updated: ConnectorConfig) => void;
}

const ConfigColumn = ({ title, colClass, sectionLabelClass, config, prefix, onChange }: ConfigColumnProps) => {
  const set = (field: keyof ConnectorConfig) => (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange({ ...config, [field]: e.target.value.trim() });

  return (
    <div className={`small-12 medium-6 ${colClass}`}>
      <p className={`pxw-col-section-label ${sectionLabelClass}`}>{title}</p>
      <StepField label="API User">
        <TextField size="small" fullWidth required name={`${prefix}-apiUser`} placeholder={`${prefix}-api-user`} value={config.apiUser} onChange={set('apiUser')} autoComplete="off" inputProps={{ autoComplete: 'off' }} />
      </StepField>
      <StepField label="Base URL">
        <TextField size="small" fullWidth required name={`${prefix}-baseUrl`} placeholder={`https://${prefix}-api.example.com`} value={config.baseUrl} onChange={set('baseUrl')} autoComplete="off" inputProps={{ autoComplete: 'off' }} />
      </StepField>
      <StepField label="Client ID">
        <TextField size="small" fullWidth required name={`${prefix}-clientId`} placeholder={`${prefix}-client-id`} value={config.clientId} onChange={set('clientId')} autoComplete="off" inputProps={{ autoComplete: 'off' }} />
      </StepField>
      <StepField label="API User Password">
        <TextField size="small" fullWidth required type="password" name={`${prefix}-apiUserPassword`} value={config.apiUserPassword} onChange={set('apiUserPassword')} autoComplete="new-password" inputProps={{ autoComplete: 'new-password' }} />
      </StepField>
      <StepField label="User Pool ID">
        <TextField size="small" fullWidth required name={`${prefix}-userPoolId`} placeholder={`${prefix}-user-pool-id`} value={config.userPoolId} onChange={set('userPoolId')} autoComplete="off" inputProps={{ autoComplete: 'off' }} />
      </StepField>
    </div>
  );
};

const VanillaSettingsStep = ({ data, onChange }: VanillaSettingsStepProps) => (
  <StepCard>
    <StepHeader
      title="Vanilla Settings"
      subtitle={
        <>
          SaaS &amp; PXW connection config &mdash; sent to&nbsp;
          <code className="pxw-code-chip">PxwTenantVanillaSettingSetup</code>
        </>
      }
    />
    <StepFormContainer>
      <div className="grid-x">
        <ConfigColumn
          title="SAAS CONFIG"
          colClass="pxw-col-left"
          sectionLabelClass="pxw-col-section-label--warning"
          config={data.saas}
          prefix="px"
          onChange={(updated) => onChange({ ...data, saas: updated })}
        />
        <ConfigColumn
          title="PXW CONFIG"
          colClass="pxw-col-right"
          sectionLabelClass="pxw-col-section-label--primary"
          config={data.pxw}
          prefix="pxw"
          onChange={(updated) => onChange({ ...data, pxw: updated })}
        />
      </div>
    </StepFormContainer>
  </StepCard>
);

export default VanillaSettingsStep;
